import React from 'react';
import { Affix,Card } from 'antd';
import MessageList from './MessagePanel';
import MessageInput from './MessageInput';
import ChatHeader from './ChatHeader';

const ChatSection = ({ 
    selectedUser,
     selectedGroup,
      chatType,
       messages, 
       currentUser,
        handleSendMessage,
         people,
         selectedChatId,
         typingMethod,
         typingPerson,
         setTypingPerson
}) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column'}}>
            {/* Chat Header */}

            <Affix offsetTop={0}>
                <ChatHeader selectedUser={selectedUser} selectedGroup={selectedGroup} chatType={chatType} />
            </Affix>

            {/* Message List */}
            <div style={{  overflowY: 'auto',height:"500px",background:'#fff' ,overflow:'hidden'}}>
                <MessageList
                    key={selectedUser ? selectedUser._id : 'default'}
                    messages={messages}
                    currentUser={currentUser}
                />
            </div>

            {/* Message Input */}
            <Affix offsetBottom={0}  >
                <div style={{ background: '#fff', borderTop: '1px solid #ddd'}}>
                    <MessageInput 
                    onSend={handleSendMessage}
                     users={people} 
                     selectedUser={selectedUser} 
                     selectedGroup={selectedGroup} 
                    currentUser={currentUser}
                    selectedChatId={selectedChatId}
                    typingMethod={typingMethod} 
                    typingPerson={typingPerson}
                    setTypingPerson={setTypingPerson}

                    />
                </div>
            </Affix>
        </div>
        
    );
};

export default ChatSection;
